import { gsap } from 'gsap'

let registered = false

/**
 * Registers any GSAP plugins the app relies on. The stream showcase performs
 * its FLIP morphs by hand, so no extra plugins are required today — this is a
 * single, idempotent entry point so future plugin needs have one home.
 */
export function registerGSAPPlugins(): void {
    if (registered) return
    registered = true
}

export { gsap }
